import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mantine/core';
import { MRT_FilterTextInput } from './MRT_FilterTextInput';
export const MRT_FilterRangeFields = ({ header, table, }) => {
    return (_jsxs(Box, { sx: { display: 'grid', gridTemplateColumns: '6fr 6fr', gap: '16px' }, children: [_jsx(MRT_FilterTextInput, { header: header, rangeFilterIndex: 0, table: table }), _jsx(MRT_FilterTextInput, { header: header, rangeFilterIndex: 1, table: table })] }));
};
//# sourceMappingURL=MRT_FilterRangeFields.js.map